module.exports = __webpack_public_path__ + "static/media/box.fc6b9cfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/box.svg
// module id = 541
// module chunks = 0